import { c as _c } from "react/compiler-runtime";
import { Inbox } from "lucide-react";
import { GlassEmptyState } from "@/shared/ui/glass";
import type { MyFeedbackEntry } from "@/presentation/rpc/feature-announcements-rpc";
import { YourFeedbackListRow } from "./your-feedback-list-row";

/**
 * The ticket-list rail (non-virtualized — a user's own feedback count sits far
 * below the virtualization threshold). Shared by the page (1/3 rail) and the
 * widget panel (stacked column).
 */
export function FeedbackTicketList(t0) {
  const $ = _c(12);
  const {
    rows,
    selectedId,
    onSelect,
    isLoading,
    error
  } = t0;
  if (isLoading && rows.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="px-3 py-4 text-sm text-gray-400">Loading your feedback...</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (error) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="px-3 py-4 text-sm text-red-500">Could not load your feedback. Please try again.</p>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (rows.length === 0) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <GlassEmptyState icon={Inbox} title="No feedback yet" description="You haven't sent any feedback yet. Use the Give feedback button to share your thoughts." />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== onSelect || $[4] !== rows || $[5] !== selectedId) {
    let t2;
    if ($[7] !== onSelect || $[8] !== selectedId) {
      t2 = t3 => {
        const {
          item,
          unread
        } = t3;
        return <YourFeedbackListRow key={item.id} item={item} unread={unread} selected={item.id === selectedId} onClick={() => onSelect(item.id, item.friendlyStatus)} />;
      };
      $[7] = onSelect;
      $[8] = selectedId;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = rows.map(t2);
    $[3] = onSelect;
    $[4] = rows;
    $[5] = selectedId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[10] !== t1) {
    t2 = <div className="space-y-1.5">{t1}</div>;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}